import { AdminPatientTableInfoEntity } from "@/domain/entity/admin/admin-patient-table-info-entity";
import { AdminRepository } from "@/domain/repository/admin-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchPatientListUsecase {
  constructor(private readonly adminRepository: AdminRepository) {}

  async execute(): Promise<SATResult<AdminPatientTableInfoEntity[], SATError>> {
    const result = await this.adminRepository.fetchPatientList();

    if (result.isSuccess) {
      console.log("[FetchPatientListUsecase] :: execute :: 환자 목록 조회 성공", result.value);
      return SATResult.success(result.value);
    }

    console.log("[FetchPatientListUsecase] :: execute :: 환자 목록 조회 실패", result.error);
    return SATResult.failure(result.error);
  }
}
